var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',[_c('div',{staticClass:"button",on:{"click":_vm.onClick}},[_c('a-icon',{staticStyle:{"font-size":"16px","margin-bottom":"8px"},attrs:{"type":"unordered-list"}}),_c('span',[_vm._v("原项目")])],1),_c('Modal',{attrs:{"visible":_vm.visible},on:{"setVisible":_vm.setVisible}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }